import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonUnion } from 'src/app/models/Union';

@Component({
  selector: 'app-union-list',
  templateUrl: 'union-list.component.html',
  styleUrls: ['./union-list.component.less', '../../../../shared/common.less'],
})

export class UnionListComponent implements OnInit {
  @Input() index: number = 0;
  @Input() list: CommonUnion;
  @Output() listChange = new EventEmitter<CommonUnion>();

  constructor() { }

  onUnionChange(index) {
    this.listChange.emit(this.list);
    
  }

  ngOnInit(): void {
  }
}
